import React, { useState } from "react";
import axios from "axios";
import API_BASE_URL from "../config";
import "../Styles/forgot.css";

export default function ForgotPassword() {
    const [username, setUsername] = useState("");
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage("");

        // Frontend validation (quick check)
        if (!username.trim()) {
            setMessage("Username is required");
            return;
        }

        if (username !== "admin") {
            setMessage("Please enter a valid username");
            return;
        }

        try {
            setLoading(true);

            const res = await axios.post(
                `${API_BASE_URL}/api/auth/forgot-password`,
                { username }
            );

            setMessage(res.data.message || "Reset link sent successfully");
        } catch (err) {
            setMessage(
                err.response?.data?.message || "Something went wrong"
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="forgot-container">
            <div className="forgot-box">

                <h2>Forgot Password</h2>

                <p className="sub-text">
                    Enter your admin username to receive a reset link.
                </p>

                <form onSubmit={handleSubmit}>
                    <input
                        type="text"
                        placeholder="Enter Username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />

                    <button type="submit" disabled={loading}>
                        {loading ? "Sending..." : "Send Reset Link"}
                    </button>
                </form>

                {message && (
                    <p className="message">{message}</p>
                )}

            </div>
        </div>
    );
}